// CoursePendingHint.tsx
// Small inline hint shown on a course card whose status is "Pending".
// It tells the creator what the next step is: the course has been sent to a
// designated approver and will go live automatically once approved.
import React from 'react';
import { Clock } from 'lucide-react';
import './CoursePendingHint.css';

interface CoursePendingHintProps {
  /** Display name of the designated approver, when known (Super Admin flow). */
  approverName?: string | null;
  /** Approver email, used when approval was routed to an external email. */
  approverEmail?: string | null;
}

const CoursePendingHint: React.FC<CoursePendingHintProps> = ({
  approverName,
  approverEmail,
}) => {
  const approver = approverName?.trim() || approverEmail?.trim() || '';

  return (
    <div className="course-pending-hint" role="status">
      <Clock size={14} className="course-pending-hint-icon" />
      <span className="course-pending-hint-text">
        {approver ? (
          <>
            Sent to <strong>{approver}</strong> for approval. Once approved, the
            course goes live for learners.
          </>
        ) : (
          <>Awaiting review. Once approved, the course goes live for learners.</>
        )}
      </span>
    </div>
  );
};

export default CoursePendingHint;
